module.exports = __webpack_public_path__ + "img/nameatl22.dcaeee9b.jpg";